import { lazy } from 'react'

export const MenChoice = lazy(() => import('./MenChoice'))
